import * as actionTypes from "Redux/Actions/actionTypes";

export const doGetStaffList = (callback = () => {}) => ({
  type: actionTypes.GET_STAFF_LIST,
  callback,
});
